import companyIcon from '@/assets/img/nav/company.svg';
import logoutIcon from '@/assets/img/nav/ic-logout.svg';
import usersIcon from '@/assets/img/nav/users-team.svg';

const AUTH_ROUTES = [
  {
    title: 'Company Wellbeing',
    icon: companyIcon,
    link: { name: 'company-wellbeing' },
  },
  {
    title: 'Admin',
    icon: usersIcon,
    link: { name: 'admin-employees' },
  },
];

const GUEST_ROUTES = [
  {
    title: 'Login',
    icon: logoutIcon,
    link: { name: 'login' },
  },
];

export { AUTH_ROUTES, GUEST_ROUTES };
